import LoadingComponent from 'components/loadingComponent/loadingComponent';

import logo from 'assets/images/logo.png';
import styles from './styles.module.scss';

function MainLoadingComponent() {
	return (
		<div className={styles.loaderContainer}>
			<img src={logo} width={300} />
			<div style={{ transform: 'scale(1.5)', marginTop: 50 }}>
				<LoadingComponent />
			</div>
		</div>
	);
}

export default MainLoadingComponent;
